'use client';

import {useLocale} from 'next-intl';

const sections = [
  {
    title: 'Pages principales',
    links: [
      {label: 'Accueil', path: ''},
      {label: 'A propos', path: '/a-propos'},
      {label: 'Actualites', path: '/actualites'},
      {label: 'Programmes', path: '/programmes'},
      {label: 'Les Aides', path: '/les-aides'},
      {label: 'Dar Ourabi', path: '/dar-ourabi'},
      {label: 'Contact', path: '/contact'},
    ],
  },
  {
    title: 'Projets & Carte',
    links: [
      {label: 'Liste des projets', path: '/projets'},
      {label: 'Projets accomplis', path: '/projets-accomplis'},
      {label: 'Carte des structures', path: '/structures'},
      {label: 'Creer un projet (agents UTSS)', path: '/projets/nouveau'},
    ],
  },
  {
    title: 'Dons & Donateurs',
    links: [
      {label: 'Faire un don', path: '/don'},
      {label: 'Espace donateur', path: '/espace-donateur'},
    ],
  },
  {
    title: 'Espace UTSS',
    links: [
      {label: 'Connexion', path: '/auth'},
      {label: 'Tableau de bord', path: '/dashboard'},
      {label: 'Journal d\'audit', path: '/audit'},
      {label: 'Gestion utilisateurs', path: '/admin/utilisateurs'},
    ],
  },
  {
    title: 'Informations legales',
    links: [
      {label: 'Mentions legales', path: '/mentions-legales'},
      {label: 'Politique de confidentialite', path: '/confidentialite'},
      {label: 'Plan du site', path: '/plan-du-site'},
    ],
  },
];

export default function PlanDuSitePage() {
  const locale = useLocale();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-primary mb-8">Plan du Site</h1>

      <div className="space-y-8">
        {sections.map((section) => (
          <div key={section.title}>
            <h2 className="text-lg font-semibold text-primary mb-3 border-b border-border pb-2">
              {section.title}
            </h2>
            <ul className="space-y-2">
              {section.links.map((link) => (
                <li key={link.path} className="flex items-center gap-2">
                  <svg className="w-3 h-3 text-primary shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                  <a
                    href={`/${locale}${link.path}`}
                    className="text-sm hover:underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
